import { environment } from '@env/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class BilSharedService {
    constructor(http) {
        this.http = http;
    }
    getDocDetails() {
        return this.http.get(environment.basePath + '/getDocDetails');
    }
    getStatus() {
        return this.http.get(environment.basePath + '/bs/status/v1');
        // return this.http.get('http://172.16.3.138:9080/bil/bs/status/v4');
    }
    getSelectedBank() {
        return this.selectedBank;
    }
    setSelectedBank(bank) {
        this.selectedBank = bank;
    }
    addPartner(data) {
        return this.http.post(environment.basePath + '/kyc/create', data);
    }
}
BilSharedService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BilSharedService_Factory() { return new BilSharedService(i0.ɵɵinject(i1.HttpClient)); }, token: BilSharedService, providedIn: "root" });
